let form = {
  items: {},
  itemsValues: {},
};

const getters = {
  GET_ITEMS(state) {
    return state.items;
  },
  GET_ITEMS_VALUES(state) {
    return state.itemsValues;
  },
};
const mutations = {
  CLEAR(state) {
    state.items = {};
    state.itemsValues = {};
  },
  ADD_ITEM(state, item) {
    state.items[item.name] = item.content;
  },
  SET_VALUE_ITEM(state, item) {
    if (state.items[item.name]) state.items[item.name]['value'] = item.value;
    else state.items[item.name] = { value: item.value };

    state.itemsValues[item.name] = item.value;
  },
};

const actions = {
  clear({ commit }) {
    commit('CLEAR');
  },
  addItem({ commit }, item) {
    commit('ADD_ITEM', item);
  },
  setValueItem({ commit }, item) {
    commit('SET_VALUE_ITEM', item);
  },
};

export default {
  namespaced: true,
  state: form,
  getters,
  mutations,
  actions,
};
